import api from "@/api/axios";

export default {
  namespaced: true,

  state: {
    balances: {},
    ordersCount: {},
  },

  getters: {
    getBalances: (state) => (apiKeyId) => {
      return state.balances[apiKeyId];
    },
    
    getOrdersCount: (state) => (apiKeyId) => {
      return state.ordersCount[apiKeyId];
    }
  },

  mutations: {
    SET_BALANCE(state, { apiKeyId, balance }) {
      state.balances[apiKeyId] = balance;
    },
    SET_ORDERS_COUNT(state, { apiKeyId, count }) {
      state.ordersCount[apiKeyId] = count;
    },
  },

  actions: {
    async fetchBalance({ commit }, apiKeyId) {
      try {
        const response = await api.get("/api/bots/wallet_balance/", {
          params: { api_key_id: apiKeyId },
        });
        commit("SET_BALANCE", { apiKeyId, balance: response.data });
      } catch (error) {
        console.error("Error fetching wallet balance:", error);
        throw error;
      }
    },
    async fetchOrdersCount({ commit }, apiKeyId) {
      try {
        const response = await api.get(
          `/api/api-keys/${apiKeyId}/open_orders_count/`
        );
        commit("SET_ORDERS_COUNT", { apiKeyId, count: response.data.count });
      } catch (error) {
        console.error("Error fetching orders count:", error);
        throw error;
      }
    },
  },
};
